{
  "@context": "https://hubmapconsortium.github.io/ccf-ontology/ccf-context.jsonld",
  "@type": "ccf:SpatialSceneNode"
}
